/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import {
  Card,
  CardContent,
  Container,
} from '@material-ui/core';
import { useTheme } from '@mui/material/styles';
import { Chart } from 'chart.js';
import { getTone } from '../../../../theme/tones';

const data = {
  series: [
    {
      color: getTone('sky').base,
      data: 56,
      name: 'Subscriptions'
    },
    {
      color: getTone('amber').light,
      data: 24,
      name: 'Affiliate'
    },
    {
      color: getTone('rose').light,
      data: 20,
      name: 'Sales'
    }
  ]
};

const CustomReportDetailsDonutChart = () => {
  const theme = useTheme();
  const chartOptions = {
    chart: {
      background: 'transparent',
      stacked: false,
      toolbar: {
        show: false
      }
    },
    colors: data.series.map((item) => item.color),
    dataLabels: {
      enabled: false
    },
    fill: {
      opacity: 1
    },
    labels: data.series.map((item) => item.name),
    legend: {
      show: false
    },
    stroke: {
      show: false
    },
    theme: {
      mode: theme.palette.mode
    }
  };

  const chartSeries = data.series.map((item) => item.data);

  return (
    <>
      <Container maxWidth="sm">
        <Card>
          <CardContent>
            <Chart
              height={300}
              options={chartOptions}
              series={chartSeries}
              type="donut"
            />
          </CardContent>
        </Card>
      </Container>
    </>
  );
};

export default CustomReportDetailsDonutChart;
